<div class="dynamic-field-container">
  <ng-container [ngSwitch]="field.FieldType">
    <!-- Text Input -->
    <ng-container *ngSwitchCase="fieldType.Text">
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <input
          matInput
          [formControl]="formControl"
          type="text"
          [readonly]="field.IsReadOnly"
          [attr.aria-label]="field.DisplayLabel"
        />
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- Textarea Input -->
    <ng-container *ngSwitchCase="fieldType.Textarea">
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <textarea
          matInput
          [formControl]="formControl"
          rows="4"
          [readonly]="field.IsReadOnly"
          [attr.aria-label]="field.DisplayLabel"
        ></textarea>
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- Number Input -->
    <ng-container *ngSwitchCase="fieldType.Number">
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <input
          matInput
          [formControl]="formControl"
          type="number"
          [readonly]="field.IsReadOnly"
          [attr.aria-label]="field.DisplayLabel"
          [attr.min]="validationRules.min"
          [attr.max]="validationRules.max"
        />
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- Email Input -->
    <ng-container *ngSwitchCase="fieldType.Email">
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <input
          matInput
          [formControl]="formControl"
          type="email"
          [readonly]="field.IsReadOnly"
          [attr.aria-label]="field.DisplayLabel"
        />
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- URL Input -->
    <ng-container *ngSwitchCase="fieldType.Url">
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <input
          matInput
          [formControl]="formControl"
          type="url"
          [readonly]="field.IsReadOnly"
          [attr.aria-label]="field.DisplayLabel"
        />
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- Phone Input -->
    <ng-container *ngSwitchCase="fieldType.Phone">
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <input
          matInput
          [formControl]="formControl"
          type="tel"
          [readonly]="field.IsReadOnly"
          [attr.aria-label]="field.DisplayLabel"
        />
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- Date Input -->
    <ng-container *ngSwitchCase="fieldType.Date">
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <input
          matInput
          [formControl]="formControl"
          [matDatepicker]="picker"
          [readonly]="field.IsReadOnly"
          [attr.aria-label]="field.DisplayLabel"
        />
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- DateTime Input -->
    <ng-container *ngSwitchCase="fieldType.DateTime">
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <input
          matInput
          [formControl]="formControl"
          type="datetime-local"
          [readonly]="field.IsReadOnly"
          [attr.aria-label]="field.DisplayLabel"
        />
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- Select Dropdown -->
    <ng-container *ngSwitchCase="fieldType.Select">
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <mat-select [formControl]="formControl" [disabled]="field.IsReadOnly" [attr.aria-label]="field.DisplayLabel">
          <mat-option *ngFor="let option of options" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- Multi-Select -->
    <ng-container *ngSwitchCase="fieldType.MultiSelect">
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <mat-select
          [formControl]="formControl"
          multiple
          [disabled]="field.IsReadOnly"
          [attr.aria-label]="field.DisplayLabel"
        >
          <mat-option *ngFor="let option of options" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- Radio Buttons -->
    <ng-container *ngSwitchCase="fieldType.Radio">
      <fieldset [attr.aria-label]="field.DisplayLabel">
        <legend>{{ field.DisplayLabel }}</legend>
        <mat-radio-group
          [formControl]="formControl"
          [disabled]="field.IsReadOnly"
          class="radio-group"
        >
          <mat-radio-button *ngFor="let option of options" [value]="option.value">
            {{ option.label }}
          </mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="formControl?.invalid && formControl?.touched" class="error-message">
          {{ getErrorMessage() }}
        </mat-error>
      </fieldset>
    </ng-container>

    <!-- Checkbox -->
    <ng-container *ngSwitchCase="fieldType.Checkbox">
      <div class="checkbox-group" [attr.aria-label]="field.DisplayLabel">
        <mat-checkbox
          [formControl]="formControl"
          [disabled]="field.IsReadOnly"
        >
          {{ field.DisplayLabel }}
        </mat-checkbox>
        <mat-error *ngIf="formControl?.invalid && formControl?.touched" class="error-message">
          {{ getErrorMessage() }}
        </mat-error>
      </div>
    </ng-container>

    <!-- Toggle Switch -->
    <ng-container *ngSwitchCase="fieldType.Toggle">
      <div class="toggle-group" [attr.aria-label]="field.DisplayLabel">
        <mat-slide-toggle
          [formControl]="formControl"
          [disabled]="field.IsReadOnly"
        >
          {{ field.DisplayLabel }}
        </mat-slide-toggle>
        <mat-error *ngIf="formControl?.invalid && formControl?.touched" class="error-message">
          {{ getErrorMessage() }}
        </mat-error>
      </div>
    </ng-container>

    <!-- Color Picker -->
    <ng-container *ngSwitchCase="fieldType.Color">
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <input
          matInput
          [formControl]="formControl"
          type="color"
          [readonly]="field.IsReadOnly"
          [attr.aria-label]="field.DisplayLabel"
        />
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <!-- Default: Unknown field type -->
    <ng-container *ngSwitchDefault>
      <mat-form-field appearance="outline" fxFlex="auto">
        <mat-label>{{ field.DisplayLabel }}</mat-label>
        <input
          matInput
          [formControl]="formControl"
          [readonly]="field.IsReadOnly"
          [attr.aria-label]="field.DisplayLabel"
        />
        <mat-error *ngIf="formControl?.invalid && formControl?.touched">
          {{ getErrorMessage() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

  </ng-container>
    </div>

